import { IMAGES } from 'constants/images';
import useMapDirection from 'hooks/map/trigger/useMapDirection';
import MapDraw from 'map/MapDraw';
import useTrackingStore from 'store/tracking';
import styles from './TrackingModeButton.module.scss';

const TrackingModeButton = () => {
  const trackingStore = useTrackingStore();

  // hook
  const { onDirectionTracking, fixCurrentRotation, offDirectionTracking } = useMapDirection();

  /**
   * 버튼을 클릭한다
   */
  const onClickDirectionTracking = async () => {
    /**
     * ON -> FIXED
     * tracking 이 켜져있다면 회전을 고정한다.
     */
    // ! 지도 회전 제거
    // if (trackingStore.trackingType === 'ON') {
    //   await fixCurrentRotation();
    //   return;
    // }

    /**
     * FIXED -> OFF
     * 방향 고정 중이라면 tracking 을 종료한다.
     */
    if (trackingStore.trackingType === 'FIXED') {
      await offDirectionTracking();
      return;
    }

    /**
     * OFF -> ON
     * tracking 이 꺼져있다면 켠다.
     */
    if (trackingStore.trackingType === 'OFF') {
      // ! 지도 회전 제거
      // await onDirectionTracking();
      await fixCurrentRotation();
    }
  };

  return (
    <div
      style={{
        transform: `rotate(${trackingStore.trackingType === 'OFF' ? 0 : MapDraw.mobileMapPosition.rotation}deg)`,
      }}
      onClick={onClickDirectionTracking}
      className={`${styles.wrapper}`}
    >
      {/* // ! 지도 회전 제거 */}
      {/* {trackingStore.trackingType === 'ON' && <img src={IMAGES.ROTATION_ON} alt='on' />} */}
      {trackingStore.trackingType === 'FIXED' && <img src={IMAGES.ROTATION_FIXED} alt='fixed' />}
      {trackingStore.trackingType === 'OFF' && <img src={IMAGES.ROTATION_OFF} alt='off' />}
    </div>
  );
};
export default TrackingModeButton;
